// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__zIaPH","vLegacy":"SelectSecondary_vLegacy__B8IaP","error":"SelectSecondary_error__3qfC1","disabled":"SelectSecondary_disabled__11hT7"};